export const MenuItems = [
  {
    title: "Inicio",
    exact: true,
    url: "/",
    cName: "nav-links",
    activeName: "main-nav-active",
  },
  {
    title: "Desinfecciones",
    url: "/Desinfecciones",
    cName: "nav-links",
    activeName: "main-nav-active",
  },
  {
    title: "Matafuegos",
    url: "/Matafuegos",
    cName: "nav-links",
    activeName: "main-nav-active",
  },
  {
    title: "Otros Servicios",
    url: "/OtrosServicios",
    cName: "nav-links",
    activeName: "main-nav-active",
  },
  {
    titlee: "Contáctanos",
    url: "",
    hreff: "#Contácto",
    cNamee: "nav-links-mobile",
    key: "contactoo",
    // activeName: "main-nav-active",
  },
];
